"use client";

import Link from "next/link";
import { useAuth } from "@/lib/AuthContext";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/Logo";
import ThemeSwitch from "@/components/ThemeSwitch";

/**
 * GuestHeader — desktop top bar for public (GuestNav) pages.
 * Holds the logo and auth CTAs so the sidebar can stay focused
 * on navigation. On mobile the GuestNav top bar serves this role instead.
 */
export function GuestHeader() {
  const { user } = useAuth();

  return (
    <header className="sticky top-0 z-40 hidden h-16 items-center justify-between gap-4 border-b border-border bg-background/80 px-6 backdrop-blur-md lg:flex">
      <div className="flex min-w-0 items-center gap-2">
        <Link
          href="/"
          className="hover:opacity-80 transition-opacity text-foreground"
        >
          <Logo className="h-11 w-auto" />
        </Link>
      </div>

      <div className="flex items-center gap-3">
        <ThemeSwitch />
        {user ? (
          <Link
            href={user.role === "course_rep" ? "/course-rep" : "/dashboard"}
          >
            <Button
              size="sm"
              className="rounded-full bg-foreground text-background font-medium"
            >
              Open App
            </Button>
          </Link>
        ) : (
          <>
            <Link href="/auth/login">
              <Button variant="ghost" size="sm">
                Log in
              </Button>
            </Link>
            <Link href="/auth/signup">
              <Button
                size="sm"
                className="rounded-full bg-foreground text-background font-medium"
              >
                Register
              </Button>
            </Link>
          </>
        )}
      </div>
    </header>
  );
}
